module.exports = __webpack_public_path__ + "img/1-2.37074455.svg";